export class RegexHelper {
	public static getRegexFromWildcard(wildcard: string, flags?: string): RegExp {
		let regex = "";
		for (let i = 0; i < wildcard.length; i++) {
			let chr = wildcard.charAt(i);
			switch (chr) {
				case "*":
					chr = ".*?";
					break;
				case "?":
					chr = ".";
					break;
				default:
					chr = RegexHelper.escapeRegExp(chr);
					break;
			}
			regex += chr;
		}
		return new RegExp(regex, flags);
	}

	private static escapeRegExp = (str: string) => {
		return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
	}
}